import { Chip } from "@mui/material";
import { WasteShipmentStatus } from "generated-graphql/graphql";

import { SHIPMENT_STATUS_LABELS } from "./shipmentDisplay";

const STATUS_COLORS: Record<
  WasteShipmentStatus,
  "default" | "info" | "success" | "warning" | "error"
> = {
  [WasteShipmentStatus.Draft]: "default",
  [WasteShipmentStatus.Requested]: "info",
  [WasteShipmentStatus.Shipped]: "success",
  [WasteShipmentStatus.Canceled]: "default",
};

export function WasteShipmentStatusChip({ status }: { status: WasteShipmentStatus }) {
  return (
    <Chip
      label={SHIPMENT_STATUS_LABELS[status]}
      color={STATUS_COLORS[status]}
      size="small"
      variant="outlined"
    />
  );
}
